export default __webpack_public_path__ + "static/create-template-638e5639942f88def88fb39c876336bc.jpg";